import Link from 'next/link';

import { Grid, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { LearnMoreLink, Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';

import SectionDynamic from './SectionDynamic';

const useStyles = makeStyles(theme => ({
  listGrid: {
    overflow: 'hidden',
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginBottom: theme.spacing(0),
    },
  },
}));

export default function Solutions(props) {
  const { className, section, title, subtitle, solutions = [], refElem, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <SectionDynamic type={section}>
      <div className={className} ref={refElem} {...rest}>
        {(title || subtitle) && <SectionHeader title={title} subtitle={subtitle} fadeUp />}
        {solutions.length > 0 && (
          <Grid container justifyContent="center">
            {solutions.map((solution, index) => (
              <Grid
                key={solution.title || index.toString()}
                item
                container
                spacing={isMd ? 4 : 2}
                data-aos="fade-up"
                alignItems="center"
                justifyContent="space-between"
                direction={index % 2 === 1 ? 'row-reverse' : 'row'}
                className={classes.listGrid}>
                <Grid item xs={12} sm={6}>
                  <SectionHeader
                    label={solution.label}
                    titleVariant="h5"
                    title={solution.title}
                    subtitle={solution.description}
                    ctaGroup={
                      solution.href && [
                        <Link href={solution.href || '/'} passHref key="learnMoreCta">
                          <LearnMoreLink title="Saiba mais" variant="h6" />
                        </Link>,
                      ]
                    }
                    align="left"
                    disableGutter
                  />
                </Grid>
                <Grid item container justifyContent="center" xs={12} sm={6}>
                  {solution.illustration?.url && (
                    <Image
                      src={solution.illustration?.url}
                      alt={solution.illustration?.alt || solution.label}
                      width="100%"
                    />
                  )}
                </Grid>
              </Grid>
            ))}
          </Grid>
        )}
      </div>
    </SectionDynamic>
  );
}

Solutions.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  refElem: PropTypes.any,
  solutions: PropTypes.array.isRequired,
};
